export default __webpack_public_path__ + "static/logo-9148c2ba00b81b9fbdda8216bab8960a.png";